export default __webpack_public_path__ + "static/media/qs.34f45974.svg";